var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.3346C2.30556 17.3346 1.71528 17.0916 1.22917 16.6055C0.743056 16.1194 0.5 15.5291 0.5 14.8346V12.3346H3V0.667969H15.5V14.8346C15.5 15.5291 15.2569 16.1194 14.7708 16.6055C14.2847 17.0916 13.6944 17.3346 13 17.3346H3ZM13 15.668C13.2361 15.668 13.434 15.5881 13.5938 15.4284C13.7535 15.2687 13.8333 15.0707 13.8333 14.8346V2.33464H4.66667V12.3346H12.1667V14.8346C12.1667 15.0707 12.2465 15.2687 12.4062 15.4284C12.566 15.5881 12.7639 15.668 13 15.668ZM5.5 6.5013V4.83464H13V6.5013H5.5ZM5.5 9.0013V7.33464H13V9.0013H5.5ZM3 15.668H10.5V14.0013H2.16667V14.8346C2.16667 15.0707 2.24653 15.2687 2.40625 15.4284C2.56597 15.5881 2.76389 15.668 3 15.668ZM3 15.668H2.16667H10.5H3Z",
    fill: "url(#paint0_linear_6433_61431)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6433_61431",
    x1: 0.5,
    y1: 2.9407,
    x2: 16.0319,
    y2: 3.62915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F52ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#845EC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.d604cd2d7c64cb498d4d5de948b5f2a4.svg";
export { ForwardRef as ReactComponent };